import React, { useEffect, useState } from "react";
import { useNetwork } from "../../../context/NetworkContext";
import { useShowAlert } from "../../../context/AlertContext";
import AxiosInstance from "../../../utils/AxiosInstance";
import handleError from "../../../constants/handleError";
import { useAuth } from "../../../context/AuthProvider";
import { usePermission } from "../../../context/PermissionContext";
import { ErrorCircleIcon, SubdirectoryRightIcon } from "../../../constants/Icons";

function ProductControl() {
  const [loading, setLoading] = useState(false);
  const { checkNetwork } = useNetwork();
 const { updateSettings } = useAuth();
 const { storeSettings } = usePermission();
  const showAlert = useShowAlert();

   const toggleItems = [
  {
    section: "productSettings",
    key: "product",
    label: "Primary Image",
    icon: "bx bx-image-add",
    color: "gray",
    subtext:
      "When enabled, the primary image will be displayed in the store.",
    settingLable: "isPrimaryImage",
  },
  {
    section: "productSettings",
    key: "productTag",
    label: "Search Tag",
    icon: "bx bx-tag",
    color: "gray",
    subtext:
      "When enabled, the Search Tag will be displayed in the store.",
    settingLable: "isProductTag",
  },
  {
    section: "advanceSettings",
    key: "minimumSalePrice",
    label: "Minimum Sale Price",
    icon: "ng ng-ng-negobill_icon",
    color: "gray",
    font:"font-22",
    subtext: "When enabled, you cannot sell a product below its minimum sale price",
    settingLable: "isMinimumSalePrice",
  },
  {
    section: "productSettings",
    key: "shortName",
    label: "Short Name",
    icon: "bi bi-file-earmark-text",
    color: "gray",
    font:"font-22",
    subtext: "When enabled, you can add product short name while adding product",
    settingLable: "isShortName",
  },
];
  const initialToggleState = toggleItems.reduce((acc, item) => {
    acc[item.key] = false;
    return acc;
  }, {});

  const [toggles, setToggles] = useState(initialToggleState);

  const handleUpdate = async (value, key, settingLable,section,extraUpdate = {},) => {
    setLoading((prev) => ({ ...prev, [key]: true }));
    try {
      if (!checkNetwork()) return;

      const data = {
        productSettings: {},
      };
      if (section === "advanceSettings") {
            data.productSettings.advanceSettings = {
              [settingLable]: value,
            };
          } else {
            data.productSettings[settingLable] = value;
          }
      const response = await AxiosInstance.patch(`module/storesettings`, data);
      const savedSettings = response.data?.results?.productSettings || {};
      const targetScope =
      section === "advanceSettings"
        ? savedSettings.advanceSettings || {}
        : savedSettings;
      if (Object.prototype.hasOwnProperty.call(targetScope, settingLable)) {
      showAlert("success", response.data.message);
       updateSettings({
      storeSettings: {
        ...storeSettings,
        productSettings: {
          ...storeSettings?.productSettings,
          ...(section === "advanceSettings"
            ? {
                advanceSettings: {
                  ...storeSettings?.productSettings?.advanceSettings,
                  [settingLable]: value,
                },
              }
            : {
                [settingLable]: value,
              }),
        },
      },
    });
      setToggles((prev) => ({ ...prev, [key]: value }));
  }
    } catch (error) {
      handleError(error, showAlert);
    } finally {
      setLoading((prev) => ({ ...prev, [key]: false }));
    }
  };

  const handlelist = async () => {
    try {
      if (!checkNetwork()) return;

      const response = await AxiosInstance.get(`module/storesettings`);
      const productSettings  = response.data?.results?.productSettings  || {};
      const advanceSettings = productSettings?.advanceSettings || {};

      const updatedToggles = {};
      toggleItems.forEach((item) => {
        if (item.section === "advanceSettings") {
          updatedToggles[item.key] =
            advanceSettings[item.settingLable] ?? false;
        } else {
          updatedToggles[item.key] = productSettings[item.settingLable] ?? false;
        }
      });

      setToggles(updatedToggles);
    } catch (error) {
      handleError(error, showAlert);
    }
  };

  const handleSwitchChange = (event, key, settingLable,section) => {
    const newValue = event.target.checked;
    handleUpdate(newValue, key, settingLable,section);
  };

  useEffect(() => {
    handlelist();
  }, []);

  const groupedSettings = [
    {
      name: "Product Settings",
      items: toggleItems.filter((i) => i.section === "productSettings"),
    },
    {
      name: "Advance Settings",
      items: toggleItems.filter((i) => i.section === "advanceSettings"),
    },
  ];

  return (
    <>
      <div className="row">
        <div className="col-lg-5">
           {groupedSettings.map((group) => (
          <div className="card mb-3" key={group.name}>
            <div className="card-header p-3 bg-light-core">
              <h6 className="mb-0 text-dark">{group.name}</h6>
            </div>
            <div className="card-body">
              {group.items                
                .map(
                  ({
                    key,
                    label,
                    icon,
                    color,
                    settingLable,
                    subtext,
                    section,
                    font
                  }) => (
                    <>
                      <div key={key} className="d-flex align-items-center">
                        <i
                          className={`${icon} ${font || "font-27"}`}
                          style={{ color: toggles[key] ? color : "gray" ,}}
                        />
                        <div className="flex-grow-1 ms-2">
                          <label className="mb-0">
                            {label}
                            <span className="tooltip-container ms-1">
                              <span className="cursor-poInter">
                                <ErrorCircleIcon/>{" "}
                              </span>
                              <span className="tooltip-text">{subtext}</span>
                            </span>
                          </label>
                        </div>
                        <div className="ms-auto custom-toggle-wrapper">
                          <label className="custom-toggle">
                            <input
                              type="checkbox"
                              checked={toggles[key] || false}
                              onChange={(e) =>
                                handleSwitchChange(
                                  e,
                                  key,
                                  settingLable,
                                  section,
                                )
                              }
                              disabled={loading[key]}
                            />
                            <span className="slider cursor-poInter">
                              {loading[key] ? (
                                <span
                                  className={`spinner-inside ${
                                    toggles[key] ? "spinner-right" : ""
                                  }`}
                                />
                              ) : (
                                <>
                                  {toggles[key] ? (
                                    <span className="label-on ms-0-1">ON</span>
                                  ) : (
                                    <span className="label-off ms-3">OFF</span>
                                  )}
                                </>
                              )}
                            </span>
                          </label>
                        </div>
                      </div>
                      {key === "bill" && toggles.bill && (
                        <div
                          className="d-flex align-items-center ms-4 mt-2 mb-2"
                          style={{ paddingLeft: "20px" }}
                        >
                          <SubdirectoryRightIcon iClass={"me-2 text-muted"}/>

                          <div className="flex-grow-1">
                            <label className="mb-0">Show Tax Information</label>
                          </div>

                          <div className="ms-auto custom-toggle-wrapper">
                            <label className="custom-toggle">
                              <input
                                type="checkbox"
                                checked={toggles.billTaxInfo || false}
                                onChange={(e) =>
                                  handleSwitchChange(
                                    e,
                                    "billTaxInfo",
                                    "isBill_isTax",
                                    "saleModeSettings",
                                  )
                                }
                                disabled={loading.billTaxInfo}
                              />

                              <span className="slider cursor-poInter">
                                {toggles.billTaxInfo ? (
                                  <span className="label-on ms-0-1">ON</span>
                                ) : (
                                  <span className="label-off ms-3">OFF</span>
                                )}
                              </span>
                            </label>
                          </div>
                        </div>
                      )}
                    </>
                  ),
                )}
            </div>
          </div>
        ))}
        </div>
      </div>
    </>
  );
}

export default ProductControl;
